import React, { PureComponent } from 'react';
import {
  withFirebase,
  firebaseConnect,
  isLoaded,
  isEmpty,
} from 'react-redux-firebase';
import Drawer from '@material-ui/core/Drawer';
import logo from '../assets/dockpad_slim_down_logo@svg.svg';
import { compose } from 'redux';
import { batch, connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import './App.css';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';

import { Route, Switch, Redirect } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import ProfileScreen from './ProfileScreen';

import TeamScreen from './TeamScreen';
import DailyHuddleScreen from './DailyHuddleScreen';
import { homeActions } from '../actions/home.actions';
import { entityActions } from '../actions/entity.actions'
import { scheduleActions } from '../actions/schedule.actions'

import AddProjectDialog from '../components/Dialogs/AddProjectDialog';
import ChangeSubscriptionDialog from '../components/Dialogs/ChangeSubscriptionDialog';
import { dockPadEntityMapToList } from './DockPadFormTemplates';
import CustomSnackbar from '../components/CustomSnackbar';
import Snackbar from '@material-ui/core/Snackbar';
import { alertActions } from '../actions/alert.actions';

import { getFirebase } from 'react-redux-firebase';
import CreateSampleProjectDialog from '../components/SampleProject';
import { Button } from '@material-ui/core';
import CircularProgressDialog from '../components/Dialogs/CircularProgressDialog';
import { dialogActions } from "../actions/dialog.actions";
import { Offline } from "react-detect-offline";
import  WifiOffIcon  from '@material-ui/icons/WifiOff';
import { getCurrentUserId } from '../selectors/user.selector'
import { getProfile } from '../selectors/profile.selector'
import { getProjectId, getProjectName, isProjectLoaded } from '../selectors/project.selector'
import { getScheduleName, getSchedule, getScheduleId } from '../selectors/schedule.selector';
import { projectActions } from '../actions/project.actions';
import { homeStyles } from './dockPadStyle'
import LeftNav from '../components/LeftNav'
import LookaheadContainer from './Lookahead/LookaheadContainer';
import PhaseTagDialogContainer from '../components/Dialogs/PhaseTagDialogContainer';
import TradeDialogContainer from '../components/Dialogs/TradeDialogContainer';
import DeleteTagDialogContainer from '../components/Dialogs/DeleteTagDialogContainer';
import DuplicateTagDialogContainer from '../components/Dialogs/DuplicateTagDialogContainer';
import RipTagDialogContainer from '../components/Dialogs/RipTagDialogContainer';
import PhasePlanDialogContainer from '../components/Dialogs/PhasePlanDialogContainer';
import MRPDialogContainer from '../components/Dialogs/MRPDialogContainer'
import PPCReportContainer from '../components/PPC_Reports/PPCReportContainer'
import AreaContainer from '../containers/AreaContainer'
import { ThunkDispatch } from 'redux-thunk';
import { uiActions } from '../actions/ui.actions';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import ConstraintLog from './ConstraintLog';
import {withGetScreen} from 'react-getscreen'
import { hasPhasePlans } from '../selectors/phaseplan.selector';
import { isSelectMultiPressed } from '../selectors/util.selector'
import { isImportScheduleDialogOpen, isUploadTasksDialogOpen, isDialogOpen } from '../selectors/dialog.selector';
import { lookaheadActions } from '../actions/lookahead.actions';

var _ = require('lodash');

interface HomeProps {
  setSelectPressed: (key:boolean) => Promise<void>,
  keyUpEvent: (key: string) => Promise<void>
  keyDownEvent: (event:any, key: string) => Promise<void>
  dispatch: any
  projectId: string | null
  classes: ClassNameMap;
  isMobile: () => boolean;
  isTablet: () => boolean;
  isProjectLoaded: boolean;
  profile:any;
  alert:any;
  currentUserId: any;
  hasPhasePlans: boolean;
  isSelectMultiPressed: boolean;
  isDialogOpen: boolean;
  lookaheadSelectedTagsClearAction: () => void;
  clearCopyTagsAction: () => void;
}

type HomeState = {
  projectListOpen: any | null,
  projectName: string | null,
  scheduleName: string | null,
  branchScheduleListOpen: any | null,
}

class HomeScreen extends PureComponent<HomeProps,HomeState> {
    isSelectMultiPressed: boolean | undefined;
    constructor(props: HomeProps) {
        super(props);
        this.state = {
          projectListOpen: null,
          branchScheduleListOpen: null
      };
    
        const firebase = getFirebase();
        const currentUser = firebase.auth().currentUser;

        if (!!currentUser && currentUser.isAnonymous) {
          currentUser.delete();
      }
    }

    handleBranchScheduleListClick = (event: any) => {
        this.setState({
          branchScheduleListOpen: event.currentTarget
      });
    }

    handleCreateSampleProjectClicked = () => {
        const { dispatch } = this.props;
        dispatch(homeActions.openCreateSampleProjectDialog());
    };

    handleEditBranchClicked = () => {
        const { dispatch, selectedScheduleId } = this.props;
        dispatch(scheduleActions.openScheduleDrawer(selectedScheduleId, '', []))
        this.handleScheduleListClose()
    }

    handleProjectListClick = (event: any) => {
        if (!!this.state.projectListOpen) return;
        this.setState({
          projectListOpen: event.currentTarget
      });
    };

    handleScheduleListClick = (event: any) => {
        if (!!this.state.branchScheduleListOpen) return;
        this.setState({
          branchScheduleListOpen: event.currentTarget
      })
    }

    handleProjectListClose = () => {
        this.setState({ projectListOpen: null });
    };

    handleScheduleListClose = () => {
        this.setState({ branchScheduleListOpen: null})
    }

    handleProjectListSelected(project) {
        const { dispatch } = this.props;
        dispatch(projectActions.selectProject(project.uid));

        this.setState({
          projectListOpen: null
      });
    }

    handleBranchListSelected(schedule) {
        const { dispatch } = this.props;

        dispatch(scheduleActions.selectSchedule(schedule.uid));
        this.handleScheduleListClose()
    }

    createProject() {
        const { dispatch } = this.props;
        dispatch(homeActions.createProject());
    }

    componentWillMount = () => {
      window.addEventListener('keydown', this.onKeyDown, {passive: true});
      window.addEventListener('keyup', this.onKeyUp, {passive: true});
  
  
    }
    
    componentWillUnmount = () => {
      window.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('keyup', this.onKeyUp);
    }
  
    onKeyUp = (event:any) => {
      setTimeout(async () => {

        //event.preventDefault();

        if(event.key === 'Control' || event.key === 'Meta' || event.key === 'Shift') {
          this.isSelectMultiPressed = false
        }

        this.props.keyUpEvent(event.key)
        if(event.key === 'Control' || event.key === 'Meta' || event.key === 'Shift') {
          this.props.setSelectPressed(false)
        }
      }, 0);
    }
    
    onKeyDown = (event:any) => {
      setTimeout(async () => {

        // already used

        const { isSelectMultiPressed, isDialogOpen, clearCopyTagsAction, lookaheadSelectedTagsClearAction } = this.props

        if(isDialogOpen) {
          return
        }


        if(event.key === 'Escape') {
          batch(() => {
            clearCopyTagsAction()
            lookaheadSelectedTagsClearAction()
          })
        }

        if(event.key === 'Control' || event.key === 'Meta' || event.key === 'Shift') {
          this.isSelectMultiPressed = true

        }

        if(!!isSelectMultiPressed) {

          //event.stopPropagation()
          //event.preventDefault()
        }

        if(!!isSelectMultiPressed) {
          this.props.keyDownEvent(event,event.key)

        }

        // we are using the event for selection
    
        if(event.key === 'Control' || event.key === 'Meta' || event.key === 'Shift') {
          //event.stopPropagation()
          //event.preventDefault()
          this.props.setSelectPressed(true)
        }

        if(!!isSelectMultiPressed) {
          if(!(event.key === 'Control') && !(event.key === 'Meta') && !(event.key === 'Shift')) {
            //event.stopPropagation()
            //event.preventDefault()
            this.props.setSelectPressed(false)
          }
        }

        return false
      }, 0);
    }


    createProjectClicked() {
        this.createProject();
        this.handleProjectListClose();
    }

    createBranchScheduleClicked() {
        const { dispatch, projectId } = this.props;
        const scheduleId = entityActions.createId(`/projects/${projectId}/schedules`)
        dispatch(scheduleActions.openScheduleDrawer(scheduleId, '', []))
        this.handleScheduleListClose()
    }

    renderProjectListName() {
        const { projectName } = this.props;
        if (!projectName || projectName === '') {
          return 'Loading...';
      }

        return `${projectName}`;
    }

    renderBranchScheduleListName() {
        const { scheduleName } = this.props;
        if (!scheduleName) {
          return 'Loading...';
      }

        return `${scheduleName}`;
    }

    renderProjectList() {
        const { profile } = this.props;
        const projects = dockPadEntityMapToList(profile.projects);
        return (
      <div className={classNames(this.props.classes.buttonWrapper)}>

        <Menu
          id="simple-menu"
          anchorEl={this.state.projectListOpen}
          open={Boolean(this.state.projectListOpen)}
          onClose={this.handleProjectListClose}
        >
          {projects.map((item) => (
            <MenuItem onClick={() => this.handleProjectListSelected(item)}>
              {item.name}
            </MenuItem>
          ))}
          <Divider />
          <MenuItem onClick={this.createProjectClicked.bind(this)}>
            Add Project
          </MenuItem>
        </Menu>
      </div>
      );
    }

    renderTeamRoute() {
        return (
      <Route
        path="/team"
        render={() => (
          <TeamScreen />
        )}
      />
      );
    }

    

    renderLookaheadPlan() {
      return  (
        <Route
          path="/lookahead"
        >
          <LookaheadContainer />
        </Route>
      )
    }

    renderConstraintLog() {
      return  (
        <Route
          path="/constraint_log"
        >
          <ConstraintLog />
        </Route>
      )
    }

    renderProfileRouter() {
        return (
      <Route
        path="/profile"
        render={() => {
            return <ProfileScreen  />;
        }}
      />
      );
    }

    renderPPCReport() {
      
      return (
        <Route
          path="/ppc_report"
          render={() => {
              return (
                <PPCReportContainer />
              )
          }}
        />
      )
    }

    renderAreas() {
      
      return (
        <Route
          path="/areas"
          render={() => {
              return (
                <AreaContainer />
              )
          }}
        />
      )
    }

    handleTimelineDialog() {
        const { dispatch } = this.props;
        dispatch(dialogActions.openTimelineDialog())
    }

    renderNavList() {
        const { classes } = this.props;
        if(this.props.isTablet() || this.props.isMobile()) {
          return (
            <React.Fragment>

            </React.Fragment>
          )
        }
        return (
      <List component="nav">
        <div className={classNames(classes.homeListDivider)}>
          <Typography
            className={classNames(
              classes.navTitle,
              classes.navTitleText,
              classes.navTextHeaders
            )}
            variant="subheading"
            align="left"
            gutterBottom
          >
            <img src={logo} className={classNames(classes.navTitleIcon)} />
            DockPad
          </Typography>
        </div>

        <div
          onClick={this.handleProjectListClick}
          className={classNames(classes.projectSearch)}
        >
          <Typography
            className={classNames(classes.projectSearchDetail)}
            variant="title"
            noWrap
          >
            {this.renderProjectListName.bind(this)()}
          </Typography>
          <ArrowDropDownIcon
            className={classNames(classes.projectSearchButton)}
          />
        </div>
        {this.renderProjectList()}
        
        <LeftNav />
      </List>
      );
    }
    
    renderMobileContent = () => {
      const { isMobile, isTablet, classes } = this.props
      if(!isMobile() && !isTablet()) {
        return
      }

      return (
        <div className={classNames(classes.mainContent)}>
          <Switch>
            <Route
                exact={true}
                path="/"
                render={() => (
                  <DailyHuddleScreen />
                )}
              />
            </Switch>
        </div>
      )
    }

    renderMainContent = () => {
        const { classes, isProjectLoaded, isMobile, isTablet } = this.props

        if (!isProjectLoaded) {
          return (
            <div
              style={{
                  width: '100%',
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex'
              }}
            >
              <CircularProgress />
            </div>
        );
      }

      if(isMobile() || isTablet()) {
        return
      }

      return (
        <div className={classNames(classes.mainContent)}>
          <Switch>
            <Route
              exact={true}
              path="/"
              render={() => (
                <DailyHuddleScreen />
              )}
            />
            {this.renderProfileRouter()}
            {this.renderPPCReport()}
            {this.renderTeamRoute()}
            {/*this.renderLookaheadPlan()*/}
            {this.renderAreas()}
          </Switch>
        </div>
      );
    }

    handleSnackbarClose = () => {
        this.props.dispatch(alertActions.clear());
    };

    renderDrawer = () => {
      const { classes } = this.props;
      if(this.props.isMobile() || this.props.isTablet()) {
        return (
          <React.Fragment>

          </React.Fragment>
        )
      }
      return (
        <Drawer
            variant="permanent"
            classes={{
                paper: classNames(classes.drawerPaper)
            }}
          >
            {this.renderNavList()}
            <div className={classNames(classes.helpCenterContainer)}>
              <Button
                onClick={() => {
                    if (!!window.Intercom) {
                        window.Intercom('show');
                    }
                }}
                size="small"
                className={classes.liveChatButton}
              >
                <ChatBubbleOutline className={classes.extendedIcon} /> Live Chat
              </Button>
              <Button
                href="https://www.notion.so/dockpad/DockPad-Updates-dca02be7a6484224817bea655f07cffe"
                className={classes.requestFeatureButton}
                size="small"
              >
                Request Feature
              </Button>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              <Typography
                      className={classNames(classes.navTextHeaders)}
                      variant="subheading"
                      align="center"
                      gutterBottom
                  >
                      {"1.0.75"}
              </Typography>
            </div>
            <Offline>
              <div className={classes.wifiDisconnected}>
                <WifiOffIcon className={classes.wifiOffIcon}/> Offline
              </div>
            </Offline>
            
          </Drawer>
      )
    }

    render() {
        const { classes, profile, alert, currentUserId, hasPhasePlans, isProjectLoaded } = this.props;

        if (!isLoaded(profile) || isEmpty(profile)) {
          return (
        <div
          style={{
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
          }}
        >
          <CircularProgress />
        </div>
        );
      }

        let alertMessage = '';
        let alertType = 'success';
        if (!_.isEmpty(alert)) {
          alertMessage = alert.message;
          if (alert.type === 'alert-success') {
            alertType = 'success';
        } else if (alert.type === 'alert-danger') {
          alertType = 'error';
      }
      }
        const intercomUser = {
          user_id: currentUserId,
          email: profile.email,
          name: `${profile.first_name} ${profile.last_name}`
      };
        return (
        <div className={classNames(classes.root)}>
          {/*<Intercom
            {...intercomUser}
            hide_default_launcher={true}
            custom_launcher_selector={'#pp'}
            appID="arwo4e1t"
          />*/}
          <CreateSampleProjectDialog />
          <AddProjectDialog />
          <ChangeSubscriptionDialog />
          <CircularProgressDialog />
          <TradeDialogContainer />
          <DeleteTagDialogContainer />
          <DuplicateTagDialogContainer />
          <PhasePlanDialogContainer />
          <RipTagDialogContainer />
          <MRPDialogContainer />
          
          {this.renderDrawer()}
          {this.renderMainContent()}
          {this.renderMobileContent()}
          <Snackbar
            open={!_.isEmpty(alert)}
            onClose={this.handleSnackbarClose}
            autoHideDuration={2000}
          >
            <CustomSnackbar
              onClose={this.handleSnackbarClose}
              variant={alertType}
              message={alertMessage}
            />
          </Snackbar>
        </div>
      );
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
      setSelectPressed: (pressed: boolean) => dispatch(uiActions.setSelectPressedAsync(pressed)),
      keyUpEvent: (key: string) => dispatch(uiActions.keyUpEventAsync(key)),
      keyDownEvent: (event:any, key: string) => dispatch(uiActions.keyDownEventAsync(event, key)),
      lookaheadSelectedTagsClearAction: () => dispatch(lookaheadActions.lookaheadSelectedTagsClearActionAsync()),
      clearCopyTagsAction: () => dispatch(dialogActions.clearCopyTagsAction())
  }
}

export default compose(
  withFirebase,
  withRouter,
  withGetScreen,
  withStyles(homeStyles, { withTheme: true }),

  connect(state => {

      return {
          projectId: getProjectId(state),
      };
  }),
  firebaseConnect((props) => {
      const { projectId } = props;

      return [
          {
              path: `projects/${projectId}`,
              storeAs: 'SELECTED_PROJECT',
              populates: [{ child: 'users', root: 'users' }]
          }
      ];
  }),
  connect((state) => {
      return {
          profile: getProfile(state),
          currentUserId: getCurrentUserId(state),
          isProjectLoaded: isProjectLoaded(state),
          projectName: getProjectName(state),
          scheduleName: getScheduleName(state),
          selectedScheduleId: getScheduleId(state),
          alert: state.alert,
          hasPhasePlans: hasPhasePlans(state),
          isSelectMultiPressed: isSelectMultiPressed(state),
          isDialogOpen: isDialogOpen(state)

      };
  },mapDispatchToProps)
)(HomeScreen);



// WEBPACK FOOTER //
// ./src/containers/HomeScreen.tsx